import Splide from '@splidejs/splide'

import regular from '../../../../node_modules/shido.regular.js/src/regular.js'

export const mainSlider = () => {
new Splide( '.main-slider',{
  rewind: true,
  pagination: false,
  breakpoints:{
    600:{
      pagination: true,
      arrows: false
    }
  }
}).mount();
}

export const serviceSlider = () => {
  new Splide( '.services-slider',{
    rewind: true,
    arrows:false,
    perPage: 1,
    gap: '1em'
  }).mount();
}

export const insuranceSlider = () => {
  const insurance = new Splide( '.insurance-slider',{
    rewind: true,
    pagination:false,
    perPage: 2,
    gap: '3em',
    breakpoints:{
      600:{
        arrows:false,
        pagination: true,
        perPage: 1
      }
    }
  })
  const insuranceRefresh = () => {
    setTimeout(()=> {
      insurance.refresh()
      new regular().init()
    },100)}

  window.insuranceRefresh = insuranceRefresh
  insurance.mount()
}



export const insuranceSliderCom = () => {

 const complete = new Splide( '.insurance-slider-1',{
    rewind: true,
    pagination:false,
    perPage: 2,
    gap: '3em',
    breakpoints:{
      600:{
        arrows:false,
        pagination: true,
        perPage: 1
      }
    }
  })
  const completeRefresh = () => {
    setTimeout(()=> {
      complete.refresh()
      new regular().init()
    },100)}

  window.completeRefresh = completeRefresh
  complete.mount()
}

export const insuranceSliderRef = () => {
  const refund = new Splide( '.insurance-slider-2',{
    rewind: true,
    pagination:false,
    perPage: 2,
    gap: '3em',
    breakpoints:{
      600:{
        arrows:false,
        pagination: true,
        perPage: 1
      }
    }
  })

  const refundRefresh = () => {
    setTimeout(()=> {
      refund.refresh()
      new regular().init()
    },100)}

  window.refundRefresh = refundRefresh
  refund.mount()
}

export const insuranceSliderDen = () => {
  const dental = new Splide( '.insurance-slider-3',{
    rewind: true,
    pagination:false,
    perPage: 2,
    gap: '3em',
    breakpoints:{
      600:{
        arrows:false,
        pagination: true,
        perPage: 1
      }
    }
  })
  const dentalRefresh = () => {
    setTimeout(()=> {
      dental.refresh()
      new regular().init()
    },100)}

  window.dentalRefresh = dentalRefresh
  dental.mount()
}

export const blogSlider = () => {
  // new Splide( '.cards-blog',{
  //   rewind: true,
  //   arrows:false,
  //   perPage: 2,
  //   gap: '3em',
  //   breakpoints:{
  //     600:{
  //       perPage: 1,
  //     }
  //   }
  // }).mount();
}

